








import { Prop, Component, Vue } from "vue-property-decorator";
import IReportOutput from "@/api/models/IReportOutput";
import IReportSceneOutput from "@/api/models/IReportSceneOutput";
import { getPhotoEntries } from "@/api/photo-api";
import { FolderEntry, Breadcrumb } from "@/models/file";

import ReportEdit from "@/templates/ReportEdit.vue";
import {
  getEntriesInCurrentFolder,
  Report,
  saveReportEntry
} from "@/api/report-api";
import ReportFormData from "@/api/models/ReportFormData";
import uploadPhoto from "@/helpers/uploadPhoto";
import formatDate from "../helpers/formatDate";

@Component({
  components: {
    ReportEdit
  }
})
export default class ReportEditPage extends Vue {
  @Prop({ required: true }) projectId!: string;
  @Prop({ required: true }) folderId!: string;
  @Prop({ required: true }) reportId!: string;

  report: IReportOutput | null = null;
  scenes: IReportSceneOutput[] = [];
  entries: FolderEntry[] = [];
  breadcrumbs: Breadcrumb[] = [];

  photoFolderId = "0";

  async ok() {
    if (!this.report) return;
    await this.save(this.report, this.scenes);
    this.goShowPage();
  }

  async cd(id: string) {
    this.photoFolderId = id;
    const { entries, path } = await getPhotoEntries(this.projectId, id);
    this.entries = entries;
    this.breadcrumbs = path;
  }

  async uploadPhoto(files: FileList) {
    if (!files.length) return;
    await uploadPhoto(this.projectId, this.photoFolderId, files[0]);
    this.cd(this.photoFolderId);
  }

  private reports: FolderEntry[] = [];

  private async created() {
    await this.initReportList();
    this.initReport();
  }

  private async initReportList() {
    const { entries } = await getEntriesInCurrentFolder(
      this.projectId,
      this.folderId
    );
    this.reports = entries;
  }

  private initReport() {
    const report = this.reports.find(r => String(r.entryId) === this.reportId);
    if (report) {
      this.report = {
        id: String(report.entryId),
        projectId: this.projectId,
        parentFolderId: String(report.parentFolderId),
        title: report.name
      };
      this.scenes = (report as Report).scenes.map(s => ({
        id: s.reportSceneId,
        state: s.state,
        date: s.date ? formatDate(s.date) : "",
        note: s.note,
        photoId: "",
        photoURL: s.imageURL,
        companyId: s.companyId
      }));
    } else {
      throw new Error("report is not found");
    }
  }

  private async save(report: IReportOutput, scenes: IReportSceneOutput[]) {
    const d = ReportFormData(report, scenes);
    await saveReportEntry(d);
  }

  private goShowPage() {
    const params = {
      projectId: this.projectId,
      folderId: this.folderId,
      reportId: this.reportId
    };
    this.$router.push({ name: "report-show", params });
  }
}
